import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider } from 'antd';
import { ExcelIcon } from 'icons';
import { Link, Route, Routes } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import Filters from 'components/filters';
import { useTranslation } from 'react-i18next';

import { useSsoUsers } from '../useSsoUsers';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const SsoUserMainPage = () => {
  const { t } = useTranslation();
  const {
    columns,
    data,
    filters,
    loading,
    handleChangeFilters,
    handleCloseFilter,
    onChangeTableFilter,
    handleDownloadExcel,
    onDelete,
    updateInProcess,
  } = useSsoUsers(true);
  const pages = useRecoilValue(getPage);
  return (
    <>
      <PageHeader title={t('UTENTI (ELENCO)').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              width={'138px'}
              disabled={loading}
              onClick={handleDownloadExcel}
              icon={<ExcelIcon fill={'#fff'} />}
            >
              {t('Export')}
            </Button>
          </Col>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button width={'138px'} big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters
          filters={filters}
          onChange={handleChangeFilters}
          onClose={handleCloseFilter}
          filterByShoppingCenter
        />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.users}
          pagination={data.pagination}
          scroll={{ x: 1200 }}
          loading={loading}
          onChange={onChangeTableFilter}
          // bordered
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal onClickDelete={onDelete} loading={updateInProcess} />
          }
        />
      </Routes>
    </>
  );
};

export default SsoUserMainPage;
